import {createSlice} from "@reduxjs/toolkit";

const initialContestsReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  auditUserFilterData : {},
  entities: [],
  exportData: [], 
  contestsReportList: [],
  allCurrency: [],
  company: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const ContestsReportSlice = createSlice({
  
  name: "contestsReportList",
  initialState: initialContestsReportState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    contestsExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },    
    contestsReportList: (state, action) => {
      const { totalCount, entities, allCurrency } = action.payload;
      // console.log("totalCount, entities slice",allCurrency)
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.allCurrency = allCurrency
    },

    company: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.company = entities;
      // state.totalCount = totalCount;
  },
  }
});

